module.exports = __webpack_public_path__ + "img/panelView_2_3.9015a471.png";